import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AnswerOptionExecution, AnswerTextExecution} from '../../../data/models/execution/answer-execution';
import {QuestionExecutionService} from './question-execution.service';

@Injectable({
  providedIn: 'root'
})
export class AnswerExecutionService {

  constructor(
    private http: HttpClient,
    private questionExecutionService: QuestionExecutionService,
  ) {
  }

  setAnswerOptionSelected(
    executionId: number, questionId: number, optionId: number,
    selected: boolean,
  ): Promise<AnswerOptionExecution> {
    if (selected) {
      return this.selectAnswerOption(executionId, questionId, optionId);
    } else {
      return this.unselectAnswerOption(executionId, questionId, optionId);
    }
  }

  selectAnswerOption(
    executionId: number, questionId: number, optionId: number
  ): Promise<AnswerOptionExecution> {

    const formData = new FormData();
    formData.append('optionId', optionId.toString());

    return this.http.post<AnswerOptionExecution>(`api/test-executions/${executionId}/questions/${questionId}/answer-options`, formData)
      .toPromise()
      .then(option => {
        this.questionExecutionService.updateQuestionOptionInCache(executionId, questionId, option);
        return option;
      });
  }

  unselectAnswerOption(
    executionId: number, questionId: number, optionId: number
  ): Promise<AnswerOptionExecution> {
    return this.http.delete<AnswerOptionExecution>(`api/test-executions/${executionId}/questions/${questionId}/answer-options/${optionId}`)
      .toPromise()
      .then(option => {
        this.questionExecutionService.updateQuestionOptionInCache(executionId, questionId, option);
        return option;
      });
  }

  updateAnswerText(
    executionId: number, questionId: number, newData: {
      text?: string,
    }): Promise<AnswerTextExecution> {

    const formData = new FormData();
    if (newData.text !== undefined) {
      formData.append('text', newData.text);
    }

    return this.http.put<AnswerTextExecution>(`api/test-executions/${executionId}/questions/${questionId}/answer-text`, formData)
      .toPromise();

  }

}
